import "./IconPlatinum.scss";
import { ReactComponent as PlatinumIcon } from "./svg/platinum.svg";

type Props = {
  color?: "black" | "blue";
};

export const IconPlatinum = (props: Props) => {
  const { color = "black" } = props;
  return (
    <span className={`IconPlatinum IconPlatinum${color}`}>
      <PlatinumIcon />
    </span>
  );
};
